import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CalendarIcon from "../../assets/icons/date_range.svg";
import CloseIcon from "../../assets/icons/close.svg";
import ValidIcon from "../../assets/icons/emergency_home.svg";
import "./CustomDatePicker.css";
import moment from "moment";

const CustomDatePicker = ({
  disabled = false,
  label,
  onChange,
  placeholderText,
  value = "",
  isError,
  isRequired = true,
  showOptional,
  allowFutureDate = false,
  allowPastDate = true,
  dateOfJoiningErr = false,
  dateOfResignErr = false,
  reqLastDateErr = false,
  minAllowedDate = null,
  maxAllowedDate = null,
}) => {
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [date, setDate] = useState();
  const [ageDiffError, setAgeDiffError] = useState();

  useEffect(() => {
    if (date) {
      setAgeDiffError(false);
      if (label === "Date of Birth") {
        const dateDiff = moment(new Date()).diff(moment(date), "years");
        if (dateDiff < 18) {
          setAgeDiffError(true);
          return;
        } else {
          setAgeDiffError(false);
          onChange(date);
        }
      } else {
        onChange(date);
      }
    }
  }, [date]);

  useEffect(() => {
    setAgeDiffError(false);
    if (value && label === "Date of Birth") {
      const dateDiff = moment(new Date()).diff(moment(value), "years");
      if (dateDiff < 18) {
        setAgeDiffError(true);
        return;
      }
    }
  }, [value]);

  const handleClearDate = () => {
    setDate("");
    onChange("");
  };

  const parsedMinAllowedDate =
    minAllowedDate && moment(minAllowedDate).isValid()
      ? moment(minAllowedDate).toDate()
      : null;
  const computedMinDate = parsedMinAllowedDate
    ? parsedMinAllowedDate
    : allowPastDate
      ? null
      : new Date();

  const parsedMaxAllowedDate =
    maxAllowedDate && !isNaN(maxAllowedDate)
      ? moment().add(maxAllowedDate, "days").toDate()
      : null;
  const computedMaxDate = parsedMaxAllowedDate
    ? parsedMaxAllowedDate
    : allowFutureDate
      ? null
      : new Date();

  const hasExplicitDateRange =
    (minAllowedDate != null && minAllowedDate !== "") ||
    (maxAllowedDate != null && maxAllowedDate !== "");

  const isDateOutsideAllowedRange = (rawDate) => {
    if (!hasExplicitDateRange || !rawDate) return false;
    const selected = moment(rawDate);
    if (!selected.isValid()) return false;
    const day = selected.clone().startOf("day");
    if (
      computedMinDate &&
      day.isBefore(moment(computedMinDate).startOf("day"))
    ) {
      return true;
    }
    if (computedMaxDate && day.isAfter(moment(computedMaxDate).startOf("day"))) {
      return true;
    }
    return false;
  };

  const dateRangeError =
    isDateOutsideAllowedRange(date) || isDateOutsideAllowedRange(value);

  return (
    (isRequired || (showOptional && !isRequired)) && (
      <div className="flex flex-col form-detail relative">
        {label && (
          <div className="emp-form-label">
            {label}
            {isRequired && "*"}
          </div>
        )}
        <DatePicker
          className={`emp-form-input ${
            (isError && !value && isRequired) ||
            ageDiffError ||
            dateOfResignErr ||
            dateOfJoiningErr ||
            dateRangeError
              ? "error-border"
              : ""
          }`}
          selected={value === "None" ? "" : value}
          onChange={(date) => {
            setDate(date);
            setOpenDatePicker(!openDatePicker);
          }}
          disabled={disabled}
          placeholderText={placeholderText}
          dateFormat={"dd-MM-yyyy"}
          onInputClick={() => setOpenDatePicker(!openDatePicker)}
          onClickOutside={() => setOpenDatePicker(!openDatePicker)}
          open={openDatePicker}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          endDate={allowFutureDate ? null : new Date()}
          maxDate={computedMaxDate}
          minDate={computedMinDate}
          startDate={computedMinDate}
        />
        <img
          src={CalendarIcon}
          style={{
            position: "absolute",
            top: "40px",
            right: "10px",
            cursor: "pointer",
          }}
          alt=""
          onClick={() => !disabled && setOpenDatePicker(!openDatePicker)}
        />
        {value && (
          <img
            src={CloseIcon}
            style={{
              position: "absolute",
              top: "40px",
              right: "40px",
              cursor: "pointer",
              height: "20px",
              width: "20px",
              backgroundColor: "#fff",
              borderRadius: "50%",
              padding: "2px",
            }}
            alt=""
            onClick={handleClearDate}
          />
        )}
        {isError && !value && isRequired && (
          <div className="valid-text flex items-center">
            <img src={ValidIcon} alt="" style={{ marginRight: "4px" }} />
            <div>Please select a date</div>
          </div>
        )}
        {dateRangeError && (
          <div className="valid-text flex items-center">
            <img src={ValidIcon} alt="" style={{ marginRight: "4px" }} />
            <div>Please select a date within the allowed range</div>
          </div>
        )}
        {ageDiffError && (
          <div className="valid-text flex items-center">
            <img src={ValidIcon} alt="" style={{ marginRight: "4px" }} />
            <div>Age should be greater than 18 years</div>
          </div>
        )}
        {dateOfResignErr &&
          (label === "Date of Exit" || label === "Date of Resignation") && (
            <div className="valid-text flex items-center">
              <img src={ValidIcon} alt="" style={{ marginRight: "4px" }} />
              <div>
                Date of exit should be greater than or equal to Date of
                resignation
              </div>
            </div>
          )}
        {dateOfJoiningErr && (
          <div className="valid-text flex items-center">
            <img src={ValidIcon} alt="" style={{ marginRight: "4px" }} />
            <div>
              Date of joining should be lower than Date of Resignation and Exit
            </div>
          </div>
        )}
        {reqLastDateErr && (
          <div className="valid-text flex items-center">
            <img src={ValidIcon} alt="" style={{ marginRight: "4px" }} />
            <div>
              Requested Last Date should be greater than Date of Resignation
            </div>
          </div>
        )}
      </div>
    )
  );
};

export default CustomDatePicker;
